export default {
  Teacher: {
    Title: 'Giáo viên: {name}'
  }
}
